<template>
  <div class="flex justify-center mt-20">
    <Pagination
      v-model="currentPage"
      :page-count="pageCount"
      :margin-pages="0"
      :page-range="mobileVariant ? 3 : 10"
      :prev-text="prevButtonName"
      :next-text="nextButtonName"
      container-class="pagination vue-pagination"
      break-view-class="break-view"
    />
  </div>
</template>

<script>
import Pagination from "vuejs-paginate"

export default {
  name: "PaginationWithDefaults",
  props: {
    value: {
      type: Number,
    },
    pageCount: {
      type: Number,
    },
  },
  components: {
    Pagination,
  },
  computed: {
    prevButtonName() {
      return this.value > 99 ? "<" : "Back"
    },
    nextButtonName() {
      return this.value > 99 ? ">" : "Next"
    },
    currentPage: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit("input", newValue)
      },
    },
  },
}
</script>
